import EnterpriseConfigureWrapper from './EnterpriseConfigureWrapper.component';

export default EnterpriseConfigureWrapper;